module.exports = __webpack_public_path__ + "drag.png?82b9c7a5a3f405032b1db71a25f67021";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drag.png
// module id = 29
// module chunks = 0